import { useEffect } from "react"
import { changeDateIntensityChart, getHeartStatsLastMonth } from "redux/reducers/heartDataReducer"
import BarChart from "components/Charts/BarChart";
import { Dashboard } from "locale/es";
import { useDispatch, useSelector } from "react-redux";

const PerMonthIntensity = () => {
  const patientId = useSelector(({ patient }) => patient.id)
  const { data, status } = useSelector(({ heartData }) => heartData.lastMonthPatientData)
  const chartData = useSelector(({ heartData }) => heartData.perDayChartIntensityInMonth)
  const maximumHR = useSelector(({ heartData }) => heartData.maximumHR);

  const dispatch = useDispatch()

  useEffect(() => {
    if (patientId && !data?.length && !status) {
      dispatch(getHeartStatsLastMonth(patientId))
    }
  }, [patientId, dispatch, data, status])

  useEffect(() => {
    if (patientId && !!status) {
      dispatch(changeDateIntensityChart())
    }
  }, [data, dispatch, patientId, status])



  return (
    <>
      {(!isNaN(maximumHR) || maximumHR === undefined) ? (
        <BarChart
          dataToShow={chartData}
          title={Dashboard.HEART_INTENSITY}
        />) : null
      }
    </>

  )
}

export default PerMonthIntensity